<template>
  <div style="background-color:#3C4663;">
    <div class="container">
      <div class="pd">
        <div class="header">
          <h3 class="text-center">
            How is upskill different?
          </h3>
        </div>

        <table>
          <tr>
            <th style="width:50%">Features</th>
            <th>CODING CAMPS</th>
            <th>UPSKILL ISA PROGRAM</th>
          </tr>
          <tr>
            <td>live Remote learning</td>
            <td><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>project based learning</td>
            <td><i class="fa fa-check"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>Zero course fee</td>
            <td><i class="fa fa-remove"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>Employer endorsed certification</td>
            <td><i class="fa fa-remove"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
          <tr>
            <td>possible Job placement with 60k salary</td>
            <td><i class="fa fa-remove"></i></td>
            <td><i class="fa fa-check"></i></td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
th {
  padding: 20px 35px;
  background: #ffc600;
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #072ac8;
}
td {
  text-transform: capitalize;
  text-align: center;
  padding: 16px;
  font-family: "Poppins";
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #181c2d;
}

th:first-child,
td:first-child {
  text-align: left;
}

tr:nth-child(even) {
  background-color: white;
}
tr:nth-child(odd) {
  background-color: white;
}

.fa-check {
  color: green;
}

.fa-remove {
  color: red;
}
.grid-1 {
  min-height: 89px;
  place-items: center;
}
.grid {
  display: grid;
  grid-template-columns: 48% 26% 26%;

  /* border: 1px solid #072ac8; */
  background-color: white;
}
.grid h2 {
  text-transform: uppercase;
  font-family: "Spartan";
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 0px;
  line-height: 24px;
  color: #072ac8;
  padding: 25px 20px 12px 20px;
}
.header h3 {
  font-family: "Spartan";
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 7.2px;
  line-height: 24px;
  padding-top: 100px;
  padding-bottom: 50px;
  color: white;
}
.pd {
  padding: 0 25px;
  max-width: 1000px;
  margin: 0 auto;
  padding-bottom: 135px;
}

@media only screen and (max-width: 600px) {
  .pd {
    padding: 0 0px;
    max-width: 1000px;
    margin: 0 auto;
    padding-bottom: 25px;
  }
  th {
    background: #ffc600;
    text-transform: uppercase;
    font-family: "Spartan";
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 24px;
    color: #072ac8;
  }
  th,
  td {
    text-transform: capitalize;
    text-align: center;
    padding: 16px;
    font-family: "Poppins";
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 24px;
    color: #181c2d;
  }
  .header h3 {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 6.4px;
    line-height: 24px;
    padding-top: 50px;
    padding-bottom: 30px;
  }
}
</style>
